import { matchPath } from 'react-router';

import { routes } from '@/constants/Constants';
import { UserPermissions, usePermission } from '@/shared/session';

export const claimsNavigation = {
  dashboardPath: routes.claimsDashboard,
  reportPath: routes.claimsReport,
  submissionFormPath: routes.claimsForm,
  submissionDetailsPath: routes.claimsSubmissionDetails,
} as const;

export function useClaimsNavigationAccess({
  allowUnsetFileClaim = false,
}: { allowUnsetFileClaim?: boolean } = {}) {
  const { notSet: canFileClaimNotSet, enabled: canFileClaimEnabled } = usePermission(
    UserPermissions.Claim.CanFileClaim,
  );
  const { enabled: canViewReport } = usePermission(UserPermissions.Claim.CanViewReport);
  const { enabled: canAccessDashboard } = usePermission(
    UserPermissions.Claim.CanAccessClaimsDashboard,
  );

  return {
    canFileClaim: canFileClaimEnabled || (allowUnsetFileClaim && canFileClaimNotSet),
    canViewReport,
    canAccessDashboard,
    canTrackClaims: canAccessDashboard || canViewReport,
    trackClaimsPath: canAccessDashboard
      ? claimsNavigation.dashboardPath
      : claimsNavigation.reportPath,
  };
}

export function isClaimsDashboardPath(pathname: string) {
  return (
    pathname === claimsNavigation.dashboardPath ||
    pathname === claimsNavigation.reportPath ||
    Boolean(matchPath(claimsNavigation.submissionDetailsPath, pathname))
  );
}
